import { render, staticRenderFns } from "./ProductsSingleCatetgoryItem.vue?vue&type=template&id=31caf188&scoped=true&"
import script from "./ProductsSingleCatetgoryItem.vue?vue&type=script&lang=js&"
export * from "./ProductsSingleCatetgoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSingleCatetgoryItem.vue?vue&type=style&index=0&id=31caf188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31caf188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VProgressCircular,VRow})
